import { Component, AfterViewInit } from '@angular/core';
declare var jQuery: any;

@Component({
  selector: 'header',
  templateUrl: 'header.template.html'
})
export class HeaderComponent implements AfterViewInit {
  ngAfterViewInit() {
    jQuery(document).ready(function() {
      jQuery('.header_content').load('assets/header.html');
    });
  }
}
